<template>
  <el-aside :class="$langConfig.cssClass" class="esb-sidenav" id="el-aside-menu"
            style="width: 200px;  scrollbar-width: none;">
    <!--    box-shadow: 1px 0 15px rgba(50,50,50,.8);-->
    <el-menu
        :collapse="isCollapsed"
        :collapse-transition="true"
        :default-active="$store.state['side-nav-state'].currentActiveSection"
        :default-openeds="currentActiveMenus"
        :router="false"
        :unique-opened="true"
        @close="handleClose"
        @select="handleOpen"
        active-text-color="#151B26"
        background-color="transparent"
        text-color="#fff">


      <div class="mb-4 mt-3 text-center">
        <img src="@/../public/portals/home/FFR/images/logo.png"
             style="border-radius: 50%; padding: 0px;opacity: .4"
             width="62px"/>

        <div class="text-white" style="margin: 10px 0;">
          {{ strCFL(getSessionData('display_name')) }}
        </div>

        <!--<router-link :to="{name: 'module->user->active->profile'}" class="text-white d-block mt-2 mb-2">

        </router-link>-->
      </div>

      <div style="position: fixed;bottom: 1px; right: 0; width: 120px;">
        <img class="d-inline-block" src="@/../public/portals/home/FFR/images/logo.png"
             style="border-radius: 50%; padding: 0px;opacity: .2" width="16px"/>
        <div class="font-weight-bold ml-1 d-inline-block" style="font-size: 8pt; opacity: .2;">
          {{ $store.state['app-state'].title }}
          {{ $store.state['app-state'].version }}
        </div>
      </div>



      <!--<el-button type="info" @click="isCollapsed = !isCollapsed"  :icon="collapseIcon" size="small" style="margin-top: 0px;margin-bottom: 30px;"></el-button>-->
      <!--<div>
        <router-link :to="{name: 'module->user->active->profile'}">
          <el-menu-item @click="linkClicked" index="module->user->active->profile">
            <i class="el-icon-user-solid module-icon"></i>
            <span class="module-label">{{ strCFL(getSessionData('display_name')) }}</span>
          </el-menu-item>
        </router-link>
      </div>-->

      <!--<div>
        <router-link :to="{name: 'portal-cpanel-dashboard'}" v-if="userProfileId == 1">
          <el-menu-item @click="linkClicked" index="portal-cpanel-dashboard">
            <i class="el-icon-menu module-icon"></i>
            <span class="module-label">Dashboard</span>
          </el-menu-item>
        </router-link>
      </div>-->


      <!-- Testing Panel Divisions -->
      <span v-if="hasTestingPanelModule">
          <div class="side-menu-group">
            <div class="sidebar-group-mark" @click="toggleClass($event, 'hidden-module-group-modules')">
              Testing Tools
            </div>
            <div id="side-menu-view-group-testing-tools-children" class="side-menu-view">
              <!--<i class="el-icon-d-arrow-right text-white" v-if="userProfileId == 1"></i>
              <div class="d-inline-block text-white m-2" style="font-size: 10pt" v-if="userProfileId == 1">TESTING TOOLS
              </div>-->
              <el-submenu index="testing-panel-module-api" v-if="hasTestingPanelModule">
                <template slot="title">
                  <i class="el-icon-phone-outline module-icon"></i>
                  <div class="d-inline-block module-label">Testing Panel</div>
                </template>
                <router-link
                    :key="key"
                    :to="{name: 'module->voip-testing-panel->division->panel-tabs->tab', params: {tabName: 'testingTool', division: division.label} }"
                    v-for="(division, key) in HassanKrayem">
                  <el-menu-item :index="'testing-panel-module-' + division.label" @click="linkClicked" class="ml-4">
                    {{ division.label }}
                  </el-menu-item>
                </router-link>
              </el-submenu>

              <el-submenu index="sms-panel-module-api" v-if="hasSmsPanelModule">
                <template slot="title">
                  <i class="el-icon-phone-outline module-icon"></i>
                  <div class="d-inline-block module-label">SMS Panel</div>
                </template>
                <router-link
                    :key="key"
                    :to="{name: 'module->voip-sms-panel->division->panel-tabs->tab', params: {tabName: 'testingTool', division: division.label} }"
                    v-for="(division, key) in smsDvisions">
                  <el-menu-item :index="'sms-panel-module-' + division.label" @click="linkClicked" class="ml-4">
                    {{ division.label }}
                  </el-menu-item>
                </router-link>
              </el-submenu>

              <!--<el-submenu index="sip-dialer-panel-module-api" v-if="userHasSipDialerModule">
                <template slot="title">
                  <i class="el-icon-phone-outline module-icon"></i>
                  <div class="d-inline-block module-label">SIP Dialer</div>
                </template>
                <router-link
                    :key="key"
                    :to="{name: 'module->voip-sip-dialer->division->panel-tabs->tab', params: {tabName: 'testingTool', division: division.label} }"
                    v-for="(division, key) in HassanKrayem">
                  <el-menu-item :index="'sip-dialer-panel-module-' + division.label" @click="linkClicked" class="ml-4">
                    {{ division.label }}
                  </el-menu-item>
                </router-link>
              </el-submenu>-->

            </div>
          </div>
      </span>


      <!-- Grouping Sip Dialer Modules-->
      <!-- Admin Generate Live - Testing Panel Divisions -->
     <!-- <span v-if="(userProfileId == 1 || userProfileId == 14 ) && userHasSipDialerModule">
          <div class="side-menu-group app-bg-color-2">
            <div class="sidebar-group-mark">
              <i class="el-icon-d-arrow-left sidebar-group-icon"></i>
              SIP Dialer
              <i class="el-icon-d-arrow-right sidebar-group-icon"></i>
            </div>


          </div>
        </span>-->


      <!-- Grouping Modules Together-->
      <div id="side-menu-modules-container">
        <div :key="key" v-for="(group, key) in visibleGroups">
          <div :class="group.bgSectionColor" :id="'side-menu-view-group-' + key" class="side-menu-group">
            <div class="sidebar-group-mark" v-if="key != 'testing-tools'"  @click="toggleClass($event, 'hidden-module-group-modules')">
              {{ getGroupName(group, key) }}
            </div>
            <div :id="'side-menu-view-group-' + key + '-children'" class="side-menu-view hidden-module-group-modules"></div>
          </div>
        </div>
      </div>

      <!-- User Modules -->
      <div :key="key" class="w-100" v-for="(module, key) in $xmodule.modules">
        <menu-link :module="$xmodule.modules[key]" :userProfileId="parseInt(userProfileId)" :groups="groups">
        </menu-link>
      </div>

    </el-menu>
  </el-aside>
</template>

<script>

import {getLS, strCFL} from 'devegram-javascript-util';
import MenuLink from './MenuLink';
import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  components: {
    MenuLink: MenuLink
  },
  mixins: [panelMixin],
  data() {
    return {
      groups: {
        'users': {
          '1': { name: 'Users' },
          bgSectionColor: ''
        },
        'servers-modules': {
          '1': { name: 'Servers' },
          bgSectionColor: ''
        },
        'testing-tools': {
          '1': { name: 'Testing Tools' },
          bgSectionColor: ''
        },
        'status-and-report': {
          '1': { name: 'Status & Report' },
          bgSectionColor: ''
        },
        'fasfreeroute-modules': {
          '1': { name: 'FFR Modules' },
          bgSectionColor: ''
        },
        'fusion-features': {
          '1': { name: 'Fusion Features' },
          bgSectionColor: ''
        },
        'sip-dialer': {
          '1': { name: 'SIP Dialer' },
          bgSectionColor: ''
        },
        'system': {
          '1': { name: 'System' },
          bgSectionColor: ''
        },
        'reports': {
          '1': { name: 'Reports' },
          bgSectionColor: ''
        },
        'voip-setting': {
          '1': { name: 'VoIP Settings' },
          bgSectionColor: ''
        },
        'voip-testing': {
          '1': { name: 'VoIP Testing' },
          bgSectionColor: ''
        },
        'voip-report': {
          '1': { name: 'VoIP Reports' },
          bgSectionColor: ''
        },
        'clients': {
          '1': { name: 'Clients' },
          bgSectionColor: ''
        },
        'general': {
          '1': { name: 'General' },
          bgSectionColor: ''
        },
        'servers': {
          '1': { name: 'Servers' },
          bgSectionColor: ''
        },
        'voip': {
          '1': { name: 'VoIP' },
          bgSectionColor: ''
        }
      },
      userProfileId: $store.state['user-state'].profile.profile_id,
      drawerOpen: true,
      tempModule: null,
      tempModuleSideMenu: null,
      tempModuleSideMenuChildren: [],
      isCollapsed: this.$store.state['side-nav-state'].isCollapsed,
      currentActiveMenus: Object.values(this.$store.state['side-nav-state'].activeSubMenus),
      hasTestingPanelModule: this.$store.hasModule('voip-testing-panel-api'),
      hasSmsPanelModule: this.$store.hasModule('voip-sms-panel-api'),
      HassanKrayem: [],
      smsDvisions:[],
      userHasSipDialerModule: $store.getters['user-state/userHasModule']('voip-sip-dialer')
    }
  },
  beforeMount() {
    this.panelMixin_getUserVoipDivision('HassanKrayem', () => {
      this.amReady = true
    })
    this.panelMixin_getUserVoipDivisionSms('smsDvisions', () => {
      this.amReady = true
    })
  },
  methods: {
    getGroupName(group, key) {
      // Return the first available group name instead of checking profile ID
      if (group['1'] && group['1'].name) return group['1'].name;
      if (group['2'] && group['2'].name) return group['2'].name;
      if (group['3'] && group['3'].name) return group['3'].name;
      if (group['4'] && group['4'].name) return group['4'].name;
      if (group['15'] && group['15'].name) return group['15'].name;
      if (group['16'] && group['16'].name) return group['16'].name;
      if (group['9'] && group['9'].name) return group['9'].name;
      
      // Fallback to key name if no group name found
      return key.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    toggleClass (e, className) {
      e.target.parentNode.childNodes[1].classList.toggle(className)
    },
    linkClicked() {
      this.$store.state['side-nav-state'].isCollapsed = true
    },
    /*...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),*/
    handleDrawerClose() {
      $store.state['app-state'].isDrawerOpen = false
    },
    moduleHasChildren(moduleName) {
      this.tempModule = null
      this.tempModuleSideMenu = null
      if (this.$xmodule.modules.hasOwnProperty(moduleName)) {
        this.tempModule = this.$xmodule.modules[moduleName]
        //this.tempModuleSideMenu = this.tempModule.sideMenu
        if (this.tempModuleSideMenu) {
          if (this.tempModuleSideMenu.hasOwnProperty('children')) {
            this.tempModuleSideMenuChildren = this.tempModuleSideMenu.children
            return true
          }
        }
      }
      return false
    },
    strCFL(s) {
      if (!s) return s;
      return strCFL(s)
    },
    getSessionData(key) {
      return getLS('user')[key]
    },
    handleOpen(key, keyPath) {
      this.$store.dispatch('side-nav-state/updateActiveMenus', {
        key: keyPath[0],
        action: 'add'
      });
      this.$store.state['side-nav-state'].currentActiveSection = key;
    },
    handleClose(key, keyPath) {
      this.$store.dispatch('side-nav-state/updateActiveMenus', {
        key: keyPath[0],
        action: 'remove'
      })
    }
  },
  computed: {
    ...$mapState('user-state', ['modules']),
    visibleGroups() {
      const visible = {};
      
      // Check which groups have actual modules with sideMenu
      if (this.$xmodule && this.$xmodule.modules) {
        Object.values(this.$xmodule.modules).forEach(module => {
          if (module.info && module.info.viewGroup && module.hasOwnProperty('sideMenu')) {
            const groupKey = module.info.viewGroup;
            if (this.groups[groupKey]) {
              visible[groupKey] = this.groups[groupKey];
            }
          }
        });
      }
      
      return visible;
    },
    collapseIcon() {
      this.$store.dispatch('sideNavStore/updateCollapsed', {
        isCollapsed: this.isCollapsed
      });
      if (this.isCollapsed) {
        return 'el-icon-d-arrow-right';
      } else {
        return 'el-icon-d-arrow-left';
      }
    }
  },
  mounted() {
    document.getElementById('el-aside-menu').style.width = '200px'
  }
}
</script>

<style lang="scss">
/*background: linear-gradient(110deg, rgba(106,28,232,1) 0%, rgba(64,36,167,1) 35%, rgba(39,33,128,1) 100%);*/
.el-menu {
  border-right: none !important;
}

.router-link-exact-active {
}

.esb-sidenav {
  font-size: 11px;
  border: none !important;
  overflow-x: hidden;
  /*width: 230px !important;*/
  transition: width .3s ease-in-out;
  height: 100vh !important;
  background-color: #031b4d;
  z-index: 10;

  .user_brief {
    .info {
    }
  }
}

.el-submenu .is-opened {
  width: 100% !important;
}

.esb-sidenav {
  a.router-link-exact-active {
    text-decoration: none !important;

    .el-menu-item i {
      /*color: #151B26 !important;*/
    }
  }
}

.esb-sidenav a.router-link-exact-active .el-menu-item {
  /*color: #151B26 !important;
  text-decoration: none !important;
  background-color: #F2F2F0 !important;*/
}

.el-submenu__title .el-icon-arrow-down {
  padding-top: 5px;
  transform: scale(1.2);
  color: #fff !important;
}

.esb-sidenav a:active {
  color: transparent;
}

.el-menu--collapse {
  .avatar-pic {
    .info {
      display: none;
    }
  }
}

.el-menu .el-menu--inline {
  background-color: #1d3752 !important;
}

.esb-sidenav .el-menu-item {
  height: 32px;
  line-height: 28px;
}

.esb-sidenav div a li.el-menu-item {
  padding-left: 5px !important;
  margin-top: 6px;
}

.esb-sidenav .el-submenu__title {
  padding: 5px !important;
  height: 40px;
  line-height: 28px;
  color: #F2F2F0;
  /*background-color: rgba(20,20,20, .5) !important;*/
}

.esb-sidenav .el-menu-item.is-active::before {
  content: "";
  width: 1px;
  height: 0px;
  position: absolute;
  left: 0px;
  display: block;
  color: #C4D4F2 !important;
  background-color: #F2F2F0;
  box-shadow: 0px 0px 2px #F2F2F0;
  transition: box-shadow .4s ease-in-out;
}

.esb-sidenav .el-menu-item.is-active {
  width: 1100% !important;
  background-color: rgba(167, 184, 217, 0.2) !important;
  box-shadow: 0px 0px 2px #F2F2F0;
  transition: box-shadow .4s ease-in-out;
}

.esb-sidenav .el-submenu__title:hover, .esb-sidenav .el-menu-item {
  width: 1100% !important;
}

.esb-sidenav .el-submenu__title:hover, .esb-sidenav .el-menu-item:hover {
  background-color: rgba(167, 184, 217, 0.2) !important;
  width: 1100% !important;
  color: #fff !important;
}

.esb-sidenav .el-submenu__title:hover i {
  /*color: #151B26;*/
}


/* rtl */
.esb-sidenav.rtl {
  overflow-x: hidden;

  .el-submenu, .el-menu-item {
    /*text-align: right;
    position: relative;
    left: 50px;*/
  }

  .is-opened .el-submenu__title {
    width: 100%;
    /*background-color: #060606 !important;
    color: #fff !important;
    width: 200%;
    margin-bottom: 12px;*/
  }
}

.el-submenu.is-opened {background-color: transparent !important;}
.esb-sidenav .el-menu-item {background-color: transparent !important;}
.esb-sidenav .el-menu-item.is-active {
  color: #fff !important;
  font-weight: bold;
  /*background-color: #464646 !important;
  box-shadow: 0 0px 2px #fff, 0 0px 2px #fff;
  width: 200% !important;*/
}

/*.esb-sidenav .el-submenu__title i {
    color: #F2F2F0;
}*/

.esb-sidenav .side-menu-group {
  /*font-family: 'Open Sans', sans-serif !important;*/
  /*font-size: 9pt !important;*/
  /*border-top: 1px solid rgba(255,255,255, 0.2);*/
  padding: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background-color: #221e1e;
  width: 100%;
}

.sidebar-group-icon {
  color: #fff;
  font-size: 9pt;
}


.side-menu-view {
  position: relative;
  opacity: 1;
  left: 0px;
  display: block;
  z-index: 1;
  transition: left .2s ease-in-out;
}

.hidden-module-group-modules {
  position: absolute;
  left: -200px;
  opacity: 0;
  transition: z-index .4s ease-out, opacity .1s ease-out, left .2s ease-in-out;
  z-index: -9;
}

.sidebar-group-mark {
  width: 100%;
  text-align: left;
  text-transform: capitalize;
  display: inline-block;
  color: #fff;
  font-size: 9pt;
  background-color: rgba( 122, 56, 160 , 0.2) !important;
  padding: 8px;
  transition: max-height .3s ease-in-out;
}

.module-icon {
  font-size: 9pt !important;
  color: #fff !important;
}

.module-label {
  font-size: 9pt !important;
}

.el-submenu__icon-arrow {
  top: 40%;
  z-index: 9000 !important;
}

</style>
